@if (errorMessage) {
  <div class="ui error message">
    <div class="header">{{header}}</div>
    <p>{{errorMessage}}</p>
  </div>
}
